import "./login.scss";
import { Button, Form, Input } from "antd";
import useLogin from "./useLogin";
import AlborLogo from "../../assets/login/albor_icon.png";
import { Link } from "react-router-dom";

/**
 * Login view rendering standalone components outside the Main Layout.
 * Consumes `useLogin` to capture Inputs intercepting the Authentication State directly overriding local scopes.
 */
function Login() {
  const { form, handleLogin, loginLoading } = useLogin();
  return (
    <div className={"login-page"}>
      <div className={"background-image-container"}></div>
      <div className={"card"}>
        <div className={"login-container"}>
          <div className={"card-image-container"}></div>
          <div className={"card-content-container"}>
            <h1>Iniciar Sesión</h1>
            <p>
              Por favor <span> ingresar datos válidos </span> que corroboren tu
              identidad
            </p>

            <Form
              requiredMark={false}
              form={form}
              className={"form"}
              style={{ width: "100%" }}
              onFinish={handleLogin}
            >
              <Form.Item name={"email"}>
                <Input placeholder="CORREO" />
              </Form.Item>
              <Form.Item name={"password"}>
                <Input type={"password"} placeholder={"CONTRASEÑA"} />
              </Form.Item>
              <Link to={"/forgot-password"}>¿Olvidaste tu contraseña?</Link>
              <Button
                type={"primary"}
                style={{ marginBottom: "12px", marginTop: "12px" }}
                htmlType={"submit"}
                loading={loginLoading.loading}
              >
                Iniciar
              </Button>

              <img
                style={{ marginTop: "60px" }}
                src={AlborLogo}
                alt={"Albor logo"}
              />
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
